import React from 'react';

import { Input } from '@components/common';

export const Text = (props) => <Input className='w-full' placeholder='Enter…' {...props} />;
